import { useTranslation } from "react-i18next"
import mixpanel from 'mixpanel-browser'
import TagButton from './TagButton'
import './RecipeTags.css'

const recipeTags = [
    {
      label: "recipe-tag.general",
      options: [
          { label: "pasta", value: "pasta" },
          { label: "meat", value: "meat" },
          { label: "fish", value: "fish" },
          { label: "chicken", value: "chicken" },
          { label: "seafood", value: "seafood" },
          { label: "pizza", value: "pizza" },

          // { label: "cheese", value: "cheese" },
          // { label: "eggs", value: "eggs" },
          // { label: "vegetables", value: "vegetables" },

          { label: "vegetarian", value: "vegetarian" },
        // { label: "vegan", value: "vegan" },
        // { label: "keto", value: "keto" },


          // { label: "beef", value: "beef" },

          // { label: "pancakes", value: "pancakes" },
          // { label: "porridge", value: "porridge" },

          // { label: "side dishes", value: "side dishes" },
          // { label: "bread", value: "bread" },
          // { label: "yeast sweet pastries", value: "yeast sweet pastries" },
          // { label: "biscuits", value: "biscuits" },
          // { label: "cakes", value: "cakes" },
          // { label: "sandwiches", value: "sandwiches" },
          // { label: "minced meat", value: "minced meat" },
          // { label: "stews", value: "stews" },
          // { label: "one pot", value: "one pot" },
          // { label: "appetizers", value: "appetizers" },
      ]
    },
    {
      label: "recipe-tag.unwanted",
      options: [

        { label: "gluten-free", value: "gluten-free" },
        { label: "dairy-free", value: "dairy-free" },
        // { label: "nut-free", value: "nut-free" },
        { label: "meat-free", value: "meat-free" },
      ]
    },
    // {
    //     label: "recipe-tag.occasion",
    //     options: [
    //       { label: "birthday", value: "birthday" },
    //       { label: "christmas", value: "christmas" },
    //       { label: "valentines-day", value: "valentines-day" },
    //       { label: "easter", value: "easter" },
    //     ]
    // },
    // {
    //     label: "recipe-tag.flavor",
    //     options: [
    //       { label: "spicy", value: "spicy" },
    //       { label: "sweet", value: "sweet" },
    //     ]
    // },
    
]

const wantedTagsGroup = recipeTags[0]
const unwantedTagsGroup = recipeTags[1]

const toggleTag = (tags, setTags, value) => {
  mixpanel.track(`Filter-${value}`)
  if (tags.includes(value)) {
    setTags(tags.filter(t => t !== value))
  } else {
    setTags([...tags, value])
  }
}

const RecipeTags = ({wantedTags, setWantedTags, unwantedTags, setUnwantedTags}) => {
  const { t } = useTranslation()
	return <div className="RecipeTags">
    <div className="recipe-tags-section">
      <div className="recipe-tags-section-options">
        {wantedTagsGroup.options.map(tag =>
          <TagButton
            key={tag.value}
            value={tag.value}
            label={t(tag.label)}
            selected={wantedTags.includes(tag.value)}
            onToggle={(val) => toggleTag(wantedTags, setWantedTags, val)}
          />
        )}
        {unwantedTagsGroup.options.map(tag =>
          <TagButton
            key={tag.value}
            value={tag.value}
            label={t(tag.label)}
            selected={unwantedTags.includes(tag.value)}
            onToggle={(val) => toggleTag(unwantedTags, setUnwantedTags, val)}
          />
        )}
      </div>
    </div>
	</div>
}

export default RecipeTags
